import { WButton } from "@/components/button/WButton.tsx";
import { ContentPane } from "@/components/ContentPane.tsx";
import { SectionHeader } from "@/components/SectionHeader.tsx";
import { useStandardSuspenseQuery } from "@/modules/api/useStandardMutation.ts";
import type { ManagedServiceWithAssigned } from "@/modules/services/joinAssignedQuery.ts";
import { getServiceSecretsQuery } from "@/modules/services/servicesQuery.ts";
import { downloadBlob } from "@/utils/downloadBlob.tsx";
import { Trans } from "@lingui/react/macro";

export function AccessContent({ item }: { item: ManagedServiceWithAssigned }) {
    const { uuid, display_name } = item;
    const serviceSecrets = useStandardSuspenseQuery(getServiceSecretsQuery, { uuid });

    // TODO: proper secrets format
    const { data } = serviceSecrets;

    function downloadSecrets() {
        if (!data.kubeconfig) {
            return;
        }
        const blob = new Blob([data.kubeconfig], { type: "text/yaml" });
        downloadBlob(blob, `${display_name}-kubeconfig.yaml`);
    }

    // TODO: might need a button with our clipboard logic
    function copyToClipboard() {
        if (document.queryCommandSupported("copy")) {
            const el = document.createElement("textarea");
            el.value = data.kubeconfig || "";
            document.body.appendChild(el);
            el.select();
            document.execCommand("copy");
            document.body.removeChild(el);
        }
    }

    return (
        <ContentPane className="VStack gap-4">
            <SectionHeader
                title={
                    <Trans comment="Title for section that contains credentials to connect to a database">Access</Trans>
                }
                description={
                    <Trans>
                        This service is accessible only by resources in the same VPC network using these private
                        addresses.
                    </Trans>
                }
            />

            <div className="flex flex-wrap gap-0.5rem">
                <WButton color="primary" icon="jp-icon-download" action={downloadSecrets}>
                    <Trans>Download config file</Trans>
                </WButton>

                <WButton icon="jp-duplicate-icon" action={copyToClipboard}>
                    <Trans>Copy config to clipboard</Trans>
                </WButton>
            </div>
        </ContentPane>
    );
}
